'use client';

import Icon from '@/components/ui/AppIcon';

interface ProgramFilterProps {
  categories: string[];
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

const ProgramFilter = ({
  categories,
  selectedCategory,
  onCategoryChange,
}: ProgramFilterProps) => {
  return (
    <div className="bg-surface rounded-xl p-6 shadow-brand-sm">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="FunnelIcon" size={20} variant="outline" className="text-brand-primary" />
        <h3 className="text-lg font-semibold text-text-primary">Filter Programs</h3>
      </div>

      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-text-primary mb-3">
            Category
          </label>
          <div className="flex flex-wrap gap-2">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => onCategoryChange(category)}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-300 ${
                  selectedCategory === category
                    ? 'bg-brand-primary text-brand-primary-foreground shadow-brand-sm'
                    : 'bg-background text-text-secondary hover:bg-muted'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramFilter;